/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const DoorClosed = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M18 20V6a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v14" }],
    ["path", { d: "M2 20h20" }],
    ["path", { d: "M14 12v.01" }]
  ]
];

export { DoorClosed as default };
//# sourceMappingURL=door-closed.js.map
